import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { apiFetch, getTheme } from 'helpers'
import styled from 'styled-components'

// Components
import SectionCover from 'components/profile/SectionCover'
import SectionBasicInfo from 'components/profile/SectionBasicInfo'
import SectionPhotos from 'components/profile/SectionPhotos'
import SectionAlbums from 'components/profile/SectionAlbums'
import SectionVideos from 'components/profile/SectionVideos'
import SectionPackages from 'components/profile/SectionPackages'

@connect(state => ({
  me: get(state, 'vendor.me')
}))
export default class extends Component {
  componentDidMount () {
    const { dispatch } = this.props
    apiFetch({
      dispatch,
      key: 'FIND_ALL_VENUES',
      v4: true,
      url: '/v4/venues',
      query: { limit: 'noLimit' }
    })
  }

  render () {
    return (
      <Container>
        <GridContainer>
          <SectionCover {...this.props} />
          <SectionBasicInfo {...this.props} />
          <InnerContainer>
            <SectionPhotos {...this.props} />
            <SectionAlbums {...this.props} />
            <SectionVideos {...this.props} />
          </InnerContainer>
          {!get(this.props, 'me.venueCategory') && (
            <SectionGroup>
              <SectionPackages {...this.props} />
            </SectionGroup>
          )}
        </GridContainer>
      </Container>
    )
  }
}

const Container = styled.section`
  background-color: ${getTheme`colorBackground`};
  padding-bottom: 50px;
`
const GridContainer = styled.div`
  max-width: 1080px;
  width: 100%;
  margin: 0 auto;
`
const InnerContainer = styled.div`
  background-color: white;
  @media(min-width: 768px) {
    padding: 0px 20px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px; 
    box-shadow: 0px 2px 2px rgba(173, 173, 173, 0.5);
  }
`
const SectionGroup = styled.div`
  margin-top: 20px;
  background-color: white;
  @media(min-width: 768px) {
    box-shadow: 0px 2px 2px rgba(173, 173, 173, 0.5);
    padding: 15px 10px;
    border-radius: 5px;
  }
  @media(max-width: 767px) {
    padding: 10px 0px;
  }
`



// WEBPACK FOOTER //
// ./src/containers/Profile.js